<template>
  <footer>
    <transition-group name="blend">
      <div class="wrapper" v-if="!$store.state.user.isLoggedIn || !user" :key="0">
        <div class="right">
          <p style="font-size: 14rem">Ved å bruker siden aksepterer du H.C. Thaugland sitt <a href="https://thaugland.no/personvern/" target="_blank">personvern og bruksvilkår</a></p>
        </div>
        <a href="https://thaugland.no" target="_blank"  rel="noopener"><img src="/img/t.png" alt="logo" class="logo"/></a>
      </div>
      <div class="wrapper" v-else-if="user" :key="1">
        <router-link to="/profile" class="wrapper right">
          <img :src="user.image || placeholder" alt="Profile Image" class="avatar"/>
          <div class="right">
            <p class="name">{{user.fullname}}</p>
            <p>{{date}}</p>
          </div>
        </router-link>
        <a href="https://thaugland.no" target="_blank" rel="noopener" class="co-link">
          <img src="/img/t.png" alt="logo" class="logo" />
          <p>v3.1</p>
        </a>
      </div>
    </transition-group>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      date: (new Date()).toLocaleDateString(),
      placeholder: 'data:image/svg+xml;utf8;base64,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',
    }
  },
  computed: {
    routeTitle () {
      return this.$store.state.route.meta ? this.$store.state.route.meta.title || '' : ''
    },
    user () {
      return this.$store.state.user.data
    },
  },
  mounted () {
    this.timer = setInterval(() => {
      this.date = (new Date()).toLocaleDateString()
    }, 60000)
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
footer {
  flex-shrink: 0;
  width: 100%;
  height: 100px;
  --topDarkColor: #75492d;
  --bottomDarkColor: #58331c;
  background: var(--topDarkColor);
  background: linear-gradient(to bottom, var(--topDarkColor) 0%,var(--bottomDarkColor) 100%);
  .wrapper {
    width: 400px;
    height: 100%;
    max-width: 100%;
    margin: 0 auto;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    font-size: 19rem;
    color: #fff;

    img {
      width: 60px;
      height: 60px;
      object-fit: contain;

      &.avatar {
        border: 1px solid var(--offwhite);
        border-radius: 8px;
        margin-right: 16px;
      }
    }

    .co-link {
      margin-left: 16px;

      .logo {
        width: 40px;
        height: 40px;
        border: none;
      }

      p {
        display: block;
        text-align: center;
        font-size: 11rem;
        margin: 0;
        padding: 0;
      }
    }


    .right {
      flex: 1;

      p {
        margin: 4px;
        font-weight: 400;
        text-shadow: 0 1px 1px rgba(0,0,0,0.7);

        &.name {
          font-weight: 600;
        }
      }

      a {
        font-weight: 600;
        color: #fff;
      }
    }
  }
}
</style>
